import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { History } from 'src/app/shared/History.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class HistoryService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "History";
    }
}

